import type * as React from 'react'
import { BackgroundAside } from './background-aside'
import { GoalsAside } from './goals-aside'
import { MotivationAside } from './motivation-aside'

/**
 * Which wizard step shows which aside, keyed by `AuditionWizardStep.id`.
 *
 * A registry rather than a property on the step data because `steps.ts` is
 * imported by the tRPC routers and the admin queue — it must stay plain,
 * server-safe data and never pull React into that bundle. The cost of the
 * indirection is that a renamed step id would silently drop its aside, so
 * `asides.test.tsx` asserts every key here names a real step.
 *
 * `Partial` is load-bearing: without it a lookup for a step that has no
 * aside — contact, account — is typed as a definitely-present
 * component, and the caller's `&&` guard reads as dead code.
 *
 * A step absent from this map has no aside, and the shell collapses its
 * grid to a single column. Contact is deliberately absent: it is the step
 * where we ask for the least and want the fewest things on screen.
 */
export const STEP_ASIDES: Partial<Record<string, React.ComponentType>> = {
  background: BackgroundAside,
  goals: GoalsAside,
  motivation: MotivationAside,
}
